<div
	class="ui-dialog-overlay closed"
	[class.confirmation-overlay]="dialogType() === 'confirmation'"
	[style.z-index]="dialogOverlayZIndex()"
	#dialogOverlay
	(click)="handleOverlayClick()"
></div>
<div
	class="ui-dialog closed"
	[style.z-index]="dialogZIndex()"
	#dialog
	[class.confirmation-dialog]="dialogType() === 'confirmation'"
	[class.size-confirmation]="sharedData()?.size === 'confirmation'"
	[class.size-default]="sharedData()?.size === 'default'"
	[class.size-large]="sharedData()?.size === 'large'"
	[class.size-auto]="sharedData()?.size === 'auto'"
	[class.size-small]="sharedData()?.size === 'small'"
	[class.size-pdf]="sharedData()?.type === 'pdf'"
	[class.size-mobile]="sharedData()?.size === 'mobile'"
>
	<!-- Sections template-->
	<ng-template #sectionsTemplate>
		@if (sharedData(); as sharedData) { @if (sharedData.sectionsConfig && sharedData.sectionsConfig.sections.length
		> 1) {

		<div class="push-top">
			<!-- Desktop version -->
			@if (!isMobileView()) {
			<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'12px'">
				<div libFlexColumn libFlexFill>
					<div libFlexRow [libFlexRowAlign]="'start'" [libFlexRowGap]="'12px'">
						@for (section of sharedData.sectionsConfig.sections; track section.id) {
						<div libFlexColumn>
							<lib-tag
								class="ui-dialog-section-tag"
								[tagType]="activeSectionId() === section.id ? 'primary' : 'basic'"
								(click)="handleSelectSection(section)"
							>
								{{ section.name }}
							</lib-tag>
						</div>
						}
					</div>
				</div>
			</div>
			} @else {
			<!-- Mobile version -->
			<div>
				<lib-tooltip-menu #sectionsTooltipMenu>
					@for (section of sharedData.sectionsConfig.sections; track section.id; let first = $first; let last
					= $last) {

					<div libConfirm>
						<lib-tooltip-menu-item
							[isFirst]="first"
							[isLast]="last"
							(itemClick)="handleSelectSection(section)"
							[title]="section.name"
						></lib-tooltip-menu-item>
					</div>

					}
				</lib-tooltip-menu>

				<div>
					<lib-button [libTooltipMenu]="sectionsTooltipMenu" [icon]="'chevronDown'" [iconLocation]="'after'">
						@for (section of sharedData.sectionsConfig.sections; track section.id) {
						<ng-container>
							@if (activeSectionId() === section.id) {
							{{ section.name }}
							}
						</ng-container>
						}
					</lib-button>
				</div>
			</div>
			}
		</div>
		} }
	</ng-template>

	<!-- Dialog container & contents -->
	<div class="container" [class.mobile]="isMobileView()">
		<div class="header" [class.mobile]="isMobileView()" #header>
			@if (sharedData(); as sharedData) {
			<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
				@if (sharedData.avatar) {
				<div libFlexColumn>
					<lib-image [alt]="'Dialog avatar'" [imageSize]="'50px'" [image]="sharedData.avatar"></lib-image>
				</div>
				}
				<div libFlexColumn libFlexFill>
					<div class="title" libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="'fill'">
							<h2 libLineClamp [clampLines]="1">
								{{ sharedData.title }}
							</h2>
							@if (sharedData.subtitle) {
							<div class="subtitle">
								{{ sharedData.subtitle }}
							</div>
							}
						</div>
					</div>
				</div>
				<div libFlexColumn>
					<div libFlexRow [libFlexRowGap]="'6px'">
						@if (sharedData.buttons) { @if (sharedData.buttons.length) {
						<div libFlexColumn>
							<lib-button-list
								[buttons]="sharedData.buttons"
								[mode]="isMobileView() ? 'single' : 'list'"
							></lib-button-list>
						</div>
						} }
						<div libFlexColumn>
							<lib-button
								[buttonType]="'basic'"
								(click)="handleCloseDialog()"
								[iconOnly]="true"
								[icon]="'close'"
							></lib-button>
						</div>
					</div>
				</div>
			</div>
			}

			<div>
				<ng-template [ngTemplateOutlet]="sectionsTemplate"></ng-template>
			</div>
		</div>
		<div class="content" [style.height]="calculatedContentHeight()">
			<div class="scroll" [class.mobile]="isMobileView()">
				@if (sharedData(); as sharedData) { @if (sharedData.text) {
				<div libWordBreak [innerHTML]="sharedData.text | textToHtml"></div>
				} @if (sharedData.type === 'image' && imageConfig(); as imageConfig) {
				<div>
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn>
							<lib-image
								[alt]="'Image preview'"
								[isRound]="false"
								[isResponsive]="true"
								[image]="imageConfig.image"
								[imageSize]="'original'"
							></lib-image>
						</div>
					</div>
				</div>
				} @if (sharedData.type === 'images' && imagesConfig(); as imagesConfig) {
				<div>
					<div [libFlexRow]="true" [libFlexRowGap]="'24px'" [libFlexRowAlign]="'center'">
						@for(image of imagesConfig.images; track image.originalImage.absoluteUrl) {
						<div libFlexColumn [style.width]="calculateFlexWidth(imagesColumnsPerRow(), 24)">
							<div libFlexRow [libFlexRowAlign]="'center'">
								<div libFlexColumn>
									<div [class.ui-dialog-image-selection-item]="imagesConfig.onSelect">
										<lib-image
											[isResponsive]="true"
											[imageSize]="'250px'"
											[maxWidth]="150"
											[maxHeight]="150"
											[alt]="'Gallery image'"
											[image]="image"
											[borderRadius]="10"
											(click)="handleSelectImage($event, imagesConfig, image)"
										></lib-image>
									</div>
								</div>
							</div>
						</div>
						}
					</div>
				</div>
				} @if (sharedData.type === 'video' && videoConfig(); as video) {
				<div>
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="'fill'">
							<lib-video [url]="video.url"></lib-video>
						</div>
					</div>
				</div>
				} @if (sharedData.type === 'genai' && genAiConfig(); as genAi) {
				<div>
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="'fill'">
							<lib-gen-ai-chat [clientContext]="genAi.clientContext"></lib-gen-ai-chat>
						</div>
					</div>
				</div>
				} @if (sharedData.type === 'snippet' && snippetConfig(); as snippet) {
				<div>
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="'fill'">
							<lib-list
								[isInDialog]="true"
								[enableSearch]="true"
								(selectItem)="handleSnippetSelectItemClick($event)"
								[categories]="snippetCategories()"
								[showNameBasedAvatar]="false"
								[design]="'selectionList'"
								[items]="snippetListItems()"
							></lib-list>
						</div>
					</div>
				</div>
				} @if (sharedData.type === 'pdf' && pdfConfig(); as pdf) {
				<div>
					@if (pdfGenerating()) {

					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libText3 libFlexColumn [libFlexSize]="undefined">
							<div>Please wait while we create your PDF.</div>
						</div>
					</div>
					<div libFlexRow [libFlexRowAlign]="'center'" class="push-top">
						<div libFlexColumn [libFlexSize]="undefined">
							<lib-loader [loaderType]="'spinner'"></lib-loader>
						</div>
					</div>

					} @if (pdfResult(); as pdfResult) {

					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="undefined">
							<div libText3>PDF has been successfully generated.</div>
						</div>
					</div>

					<div libFlexRow [libFlexRowAlign]="'center'" class="push-top">
						<div libFlexColumn [libFlexSize]="undefined">
							<lib-button
								[buttonType]="'primaryLight'"
								[icon]="'download'"
								(click)="handleDownloadPdf(pdfResult.pdfUrl)"
								>Download
							</lib-button>
						</div>
					</div>

					}
				</div>
				} @if (sharedData.type === 'foodAmount' && extendedFoodAmountConfig(); as extendedFoodAmountconfig) {
				<div>
					@if (!isMobileView()) {
					<div>
						<div libFlexRow libText5>
							<div libFlexColumn [libFlexSize]="'200px'">Amount</div>
							<div libFlexColumn [libFlexSize]="'fill'">Unit</div>
						</div>
						<div libFlexRow class="push-top-sm" [libFlexRowAlign]="'start'">
							<div libFlexColumn [libFlexSize]="'200px'">
								<ui-number-form-field
									[placeholder]="''"
									[isRequired]="true"
									[maxValue]="extendedFoodAmountconfig.amountMaxValue"
									[minValue]="1"
									[valueAsSignal]="extendedFoodAmountconfig.amountSignal"
									(requiredValueChange)="handleAmountChanged($event)"
								></ui-number-form-field>
							</div>
							<div libFlexColumn [libFlexSize]="'fill'">
								<ui-select-item-field
									[placeholder]="'Measurement unit...'"
									[design]="'default'"
									[isRequired]="true"
									[items]="extendedFoodAmountconfig.portionSelectionItems"
									[valueAsSignal]="extendedFoodAmountconfig.portionIdSignal"
									(requiredValueChange)="handleSetPortion($event)"
								></ui-select-item-field>
							</div>
						</div>

						<div class="push-top" libFlexRow>
							@if (foodAmountText(); as foodAmountText) {
							<div libFlexColumn [libFlexSize]="'200px'">
								<lib-tag [tagType]="'basic'">{{ foodAmountText }}</lib-tag>
							</div>
							} @if (foodAmountNutrition(); as foodAmountNutrition) {
							<div libFlexColumn libFlexFill>
								<lib-nutrition-boxes
									[design]="'tagsAlt'"
									[nutritionRowAlign]="'start'"
									[kcal]="foodAmountNutrition.kcal"
									[carbs]="foodAmountNutrition.carbs"
									[proteins]="foodAmountNutrition.proteins"
									[fats]="foodAmountNutrition.fats"
								></lib-nutrition-boxes>
							</div>
							}
						</div>
					</div>
					} @else {
					<div>
						<div libFlexRow [libFlexRowAlign]="'center'">
							<div libFlexColumn [libFlexSize]="'fill'" libText5>Amount</div>
							<div libFlexColumn [libFlexSize]="'200px'">
								<ui-number-form-field
									[placeholder]="''"
									[isRequired]="true"
									[maxValue]="extendedFoodAmountconfig.amountMaxValue"
									[minValue]="1"
									[valueAsSignal]="extendedFoodAmountconfig.amountSignal"
									(requiredValueChange)="handleAmountChanged($event)"
								></ui-number-form-field>
							</div>
						</div>
						<div libFlexRow class="push-top" [libFlexRowAlign]="'center'">
							<div libFlexColumn [libFlexSize]="'fill'" libText5>Unit</div>
							<div libFlexColumn [libFlexSize]="'200px'">
								<ui-select-item-field
									[placeholder]="'Measurement unit...'"
									[design]="'default'"
									[items]="extendedFoodAmountconfig.portionSelectionItems"
									[valueAsSignal]="extendedFoodAmountconfig.portionIdSignal"
									(requiredValueChange)="handleSetPortion($event)"
								></ui-select-item-field>
							</div>
						</div>

						<div class="push-top" libFlexRow>
							@if (foodAmountText(); as foodAmountText) {
							<div libFlexColumn [libFlexSize]="'fill'">
								<lib-tag [tagType]="'basic'">{{ foodAmountText }}</lib-tag>
							</div>
							}
						</div>

						<div class="push-top" libFlexRow>
							@if (foodAmountNutrition(); as foodAmountNutrition) {
							<div libFlexColumn libFlexFill>
								<lib-nutrition-boxes
									[design]="'alt'"
									[nutritionRowAlign]="'start'"
									[kcal]="foodAmountNutrition.kcal"
									[carbs]="foodAmountNutrition.carbs"
									[proteins]="foodAmountNutrition.proteins"
									[fats]="foodAmountNutrition.fats"
								></lib-nutrition-boxes>
							</div>
							}
						</div>
					</div>
					}
				</div>
				} @if (sharedData.type === 'form' && formConfig(); as form) {
				<div>
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="'fill'">
							@for (field of form.fields; track field.propertyName; let first = $first) {
							<div [class.push-top-md]="!first">
								@if (field.type === 'text') {
								<ui-text-form-field
									[title]="field.title"
									[isRequired]="field.required"
									[valueAsSignal]="getFormFieldValueAsString(form, field)"
									(valueChange)="handleFormFieldValueChange(form, field, $event)"
									[maxLength]="field.maxLength"
									[isInDialog]="false"
								></ui-text-form-field>
								} @else if (field.type === 'number') {
								<ui-number-form-field
									[title]="field.title"
									[isRequired]="field.required"
									[valueAsSignal]="getFormFieldValueAsNumber(form, field)"
									(valueChange)="handleFormFieldValueChange(form, field, $event)"
									[maxValue]="field.maxValue"
									[minValue]="field.minValue"
									[isInDialog]="false"
								></ui-number-form-field>
								} @else if (field.type === 'dateTime') {
								<ui-date-time-form-field
									[title]="field.title"
									[isRequired]="field.required"
									[valueAsSignal]="getFormFieldValueAsDatetime(form, field)"
									(valueChange)="handleFormFieldValueChange(form, field, $event)"
									[isInDialog]="false"
								></ui-date-time-form-field>
								} @else if (field.type === 'textarea') {
								<ui-text-area-form-field
									[title]="field.title"
									[isRequired]="field.required"
									[valueAsSignal]="getFormFieldValueAsString(form, field)"
									(valueChange)="handleFormFieldValueChange(form, field, $event)"
									[maxLength]="field.maxLength"
									[isInDialog]="false"
								></ui-text-area-form-field>
								} @else if (field.type === 'image') { @if (field.fileUpload) {
								<ui-file-form-field
									[validation]="'images'"
									[maxFiles]="1"
									[imageCrop]="field.imageCrop"
									[imageGalleryDisplayMode]="'inline'"
									[isRequired]="false"
									[enableImageGallery]="field.enableImageGallery ?? false"
									[uploadFunction]="field.fileUpload"
									(deleteFile)="handleFormFieldFileDelete(form, field, $event)"
									(selectFile)="handleFormFieldFileSelect(form, field, $event)"
									[valueAsSignal]="getFormFieldValueAsFileReferences(form, field)"
									(valueChange)="handleFormFieldValueChange(form, field, $event)"
									[isInDialog]="false"
								></ui-file-form-field>
								} @else {
								<lib-message [type]="'warning'">Missing file upload function config</lib-message>
								} }
							</div>
							}
						</div>
					</div>
				</div>
				} @if (sharedData.type === 'selection' && selectionConfig(); as selectionConfig) {
				<div>
					<lib-list
						[isInDialog]="true"
						[enableSearch]="true"
						(selectItem)="handleSelectionItemClick($event)"
						[showNameBasedAvatar]="false"
						[avatarMode]="selectionConfig.avatarMode ?? 'preferImage'"
						[design]="selectionConfig.design ?? 'selectionList'"
						[items]="selectionItems()"
						[enableMultiSelect]="selectionConfig.enableMultiSelect ?? false"
						[disableSort]="selectionConfig.disableSort ?? false"
					></lib-list>
				</div>
				} @if (sharedData.type === 'exercise') {
				<div>
					<lib-select-exercise-list
						[isInDialog]="true"
						(selectItem)="handleExerciseSelectItemClick($event)"
						[items]="exerciseConfig()?.items ?? []"
					></lib-select-exercise-list>
				</div>
				} @if (contentTemplate(); as contentTemplate) {
				<div>
					<ng-container *ngTemplateOutlet="contentTemplate"> </ng-container>
				</div>
				} @if (sharedData.type === 'azureSearch' && azureSearchConfig(); as azureSearch) {
				<div>
					<div>
						<lib-search-input [debounceTime]="30" (search)="handleAzureSeach($event)"> </lib-search-input>
					</div>
					<div class="push-top-md">
						@if (azureSearchItemsLoaded()) {
						<lib-list
							[isInDialog]="true"
							[enableSearch]="false"
							(selectItem)="handleSelectAzureSearchItem($event)"
							[design]="'selectionList'"
							[showNameBasedAvatar]="false"
							[items]="azureSearchItems()"
						></lib-list>
						}
					</div>
				</div>
				} @if (sharedData.type === 'text' && textConfig(); as textConfig) {
				<div>
					@if (textConfig.tableItems) {
					<div>
						@if (sharedData.text) {
						<lib-divider [mode]="'dotted'" class="push-top push-bottom"></lib-divider>
						}
						<ui-simple-table [items]="textConfig.tableItems"></ui-simple-table>
					</div>
					}
				</div>
				} @if (sharedData.message) {
				<div class="push-top-md">
					<lib-message
						[type]="sharedData.message.type"
						[title]="sharedData.message.title"
						[icon]="sharedData.message.icon"
						>{{ sharedData.message.message }}</lib-message
					>
				</div>
				} @if (sharedData.code) {
				<div class="push-top-md">
					@if (sharedData.code.format === 'json') {
					<pre class="w-dialog-code">{{ sharedData.code.code | json }}</pre>
					} @else {
					<pre class="w-dialog-code">{{ sharedData.code.code }}</pre>
					}
				</div>
				} }

				<!-- Content Footer Buttons -->
				@if (footerButtons(); as footerButtons) { @if (footerButtonLocation() === 'content' &&
				footerButtons.length) {
				<div libFlexRow [libFlexRowAlign]="'start'" class="push-top-md">
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
						<lib-button-list [mode]="'list'" [buttons]="footerButtons"></lib-button-list>
					</div>
				</div>
				} }
			</div>
		</div>
		@if (footerButtons(); as footerButtons) { @if (footerButtonLocation() === 'bottom' && footerButtons.length) {
		<div class="footer" [class.mobile]="isMobileView()" #footer>
			<div libFlexRow [libFlexRowAlign]="dialogType() === 'confirmation' ? 'end' : 'start'">
				<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
					<lib-button-list [mode]="'list'" [buttons]="footerButtons"></lib-button-list>
				</div>
			</div>
		</div>
		} }
	</div>
</div>
